import React, { useEffect, useState } from 'react'
import { standardsApi } from '@edulastic/api'
import produce from 'immer'
import { dashBorderColor } from '@edulastic/colors'
import { compose } from 'redux'
import { connect } from 'react-redux'
import get from 'lodash/get'
import StandardSet from '../../../AssessmentPage/components/QuestionEditModal/common/StandardSet/StandardSet'
import { standardsFields } from '../../../AssessmentPage/VideoQuiz/constants'

const SelectCurriculumAndStandards = ({
  curriculumsData,
  handleChange,
  checkDuplicateGroup,
  index,
  itemGroup,
  currentGroupIndex,
  currentGroupDetails = {},
}) => {
  const [alignmentFieldValue, setAlignmentFieldValue] = useState()
  const [isFetchingStandards, setIsFetchingStandards] = useState(false)

  useEffect(() => {
    const fetchStandards = async () => {
      if (Number.isFinite(index) && itemGroup && curriculumsData?.length) {
        const { standardDetails } = itemGroup

        if (!standardDetails) return

        const { _id: curriculumId, curriculum } =
          curriculumsData.find(
            ({ _id }) => _id === standardDetails?.standards?.[0]?.curriculumId
          ) || {}

        if (standardDetails?.standards?.length > 0) {
          const paIds = standardDetails.standards.map((std) => std.standardId)
          try {
            setIsFetchingStandards(true)
            const result = await standardsApi.getPaStandards({ paIds })
            if (result) {
              setAlignmentFieldValue([
                produce(standardDetails, (draft) => {
                  if (result?.length && result?.[0]?.curriculumId) {
                    draft.curriculumId = curriculumId
                    draft.curriculum = curriculum
                    draft.standards = result
                  }
                }),
              ])
              setIsFetchingStandards(false)
            }
          } catch (error) {
            console.error('Error fetching standards:', error)
          }
        } else {
          setAlignmentFieldValue([
            produce(standardDetails, (draft) => {
              if (draft?.[0]?.curriculumId) {
                draft.curriculumId = draft?.[0].curriculumId
                draft.curriculum = draft?.[0].curriculum
              }
            }),
          ])
        }
      }
    }

    fetchStandards()
  }, [index, curriculumsData])

  const handleStandardsChange = (standardDetails) => {
    handleChange('standardDetails', standardDetails)
  }

  const onAlignmentChange = (data, isInitialLoad? = false) => {
    if (isFetchingStandards || currentGroupIndex !== index) return
    if (isInitialLoad) {
      setAlignmentFieldValue(data.alignment)
      return
    }
    const { collectionDetails } = currentGroupDetails

    const standardDetails = produce(data?.alignment[0] || {}, (draft) => {
      const grades = []
      draft.standards = draft.standards.map((std) => {
        const { curriculumId, tloId, _id, grades: stGrades = [] } = std

        grades.push(...stGrades)
        return {
          curriculumId,
          standardId: _id,
          domainId: tloId,
        }
      })
      draft.grades = grades
    })

    const { standards = [] } = standardDetails
    if (standardDetails && !isInitialLoad) {
      const { subject, grades } = standardDetails
      const uniqueGrades = new Set(grades)
      if (
        collectionDetails &&
        standardDetails &&
        checkDuplicateGroup(collectionDetails._id, standardDetails)
      )
        return

      setAlignmentFieldValue(data.alignment)

      handleStandardsChange({
        subject,
        grades: Array.from(uniqueGrades),
        standards,
      })
    }
  }

  return (
    <StandardSet
      disabled={currentGroupIndex !== index}
      alignment={alignmentFieldValue}
      onUpdate={onAlignmentChange}
      showIconBrowserBtn
      hideLabel
      standardsRequiredFields={[
        standardsFields.SUBJECT,
        standardsFields.STANDARD_SET,
      ]}
      required={false}
      trackingEventSource="Dynamic Test Authoring"
      height="40px"
      inputPaddingRight="0px !important"
      inputPaddingLeft="0px !important"
      inputMargin="0 -1px 0 0"
      inputBorderColor={dashBorderColor}
      isDynamicTest
      isFetchingStandards={isFetchingStandards}
      enableSelectAll
    />
  )
}

const enhance = compose(
  connect((state) => ({
    curriculumsData: get(state, 'dictionaries.curriculums.curriculums', []),
  }))
)
export default enhance(SelectCurriculumAndStandards)
